var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.04821 12V11.2103L7.85179 11.0564V7.4L7 7.24615V6.45128H9.20179V11.0564L10 11.2103V12H7.04821ZM7.79821 5.19487V4H9.20179V5.19487H7.79821Z","fill":"currentColor"}));
}

Info.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Info;

Info.default = Info;
